import { IconProps } from '../icon-props-interface';
import '../icons.scss';

const IconChevronDown = ({ color = 'var(--color-accent-1)' }: IconProps): JSX.Element => (
    <div className="icon-block">
        <svg width="15" height="9" viewBox="0 0 15 9" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.38026 7.85512L14.6103 1.73896C14.7545 1.5975 14.834 1.40867 14.834 1.20732C14.834 1.00597 14.7545 0.817133 14.6103 0.675674L14.1516 0.225262C13.8527 -0.0678244 13.367 -0.0678244 13.0685 0.225262L7.83689 5.36114L2.59945 0.219563C2.45524 0.0781037 2.263 -5.43957e-07 2.05801 -5.52827e-07C1.85279 -5.61707e-07 1.66055 0.0781037 1.51622 0.219563L1.05764 0.669975C0.913431 0.811546 0.833984 1.00027 0.833984 1.20162C0.833984 1.40297 0.913431 1.59181 1.05764 1.73326L7.2934 7.85512C7.43806 7.99691 7.63121 8.07479 7.83655 8.07434C8.04267 8.07479 8.23571 7.99691 8.38026 7.85512Z"
                  fill={color}
            />
        </svg>

    </div>
);

export default IconChevronDown;
